import React, { Component } from "react";
import Field from "../Common/Field";
import { withFormik } from "formik";
import * as Yup from "yup";
import logo from "../assets/img/logo.jpg";
import { Link } from "react-router-dom";
import Axios from "axios";

const fields = [
  {
    name: "CNIC",
    elementName: "input",
    type: "tel",
    placeholder: "Your CNIC: 1310133049545",
    max: "13",
    min: "13",
  },
  {
    name: "email",
    elementName: "input",
    type: "email",
    placeholder: "Your email",
  },
  {
    name: "password",
    elementName: "input",
    type: "password",
    placeholder: "Your Password",
  },
];
class Login extends Component {
  render() {
    return (
      <div className="login-page" id="login">
        <div className="container">
          <div className="login-form">
            <Link to="/">
              {" "}
              <img
                src={logo}
                style={{
                  width: "10rem",
                  height: "3.5rem",
                  borderRadius: "1rem",
                }}
                alt="..."
              />
            </Link>
            <div className="row">
              <h1>Sign in</h1>
            </div>
            <div className="row">
              <form onSubmit={this.props.handleSubmit} method="post">
                {fields.map((f, i) => {
                  return (
                    <div className="col-md-12">
                      <Field
                        key={i}
                        {...f}
                        value={this.props.values[f.name]}
                        name={f.name}
                        onChange={this.props.handleChange}
                        onBlur={this.props.handleBlur}
                        touched={this.props.touched[f.name]}
                        errors={this.props.errors[f.name]}
                      />
                    </div>
                  );
                })}

                <div className="col-md-12">
                  {" "}
                  <button type="submit" className="btn btn-primary">
                    Login
                  </button>
                  <h6 style={{ textAlign: "right" }}>Not Registered: </h6>
                  <Link to="/Signup">
                    {" "}
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ float: "right" }}
                    >
                      Sign Up
                    </button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withFormik({
  mapPropsToValues: () => ({
    CNIC: "",
    email: "",
    password: "",
  }),
  validationSchema: Yup.object().shape({
    CNIC: Yup.string()
      .required("You need to enter your CNIC.")
      .max(13, "Enter a 13 Digits CNIC, not more!")
      .min(13, "Enter a 13 Digits CNIC, not less! ")
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        "CNIC is not Valid"
      ),
    email: Yup.string()

      .email("Email is invalid.")
      .required("You need to login with email address."),
    password: Yup.string()
      .required("You need to enter your password.")
      .min(8, "Minimum 8 characters allowed"),
  }),

  handleSubmit: (values, { setSubmitting }, login) => {
    // alert("Login Success", values);
    //login(values.email, values.password);
    Axios.post("http://localhost:3001/login", values).then((response) => {
      console.log("OK", values);
      //  alert("sign in successful");
    });
  },
})(Login);
